import { DataConnectorsType } from "@/types/DataConnectorsType"

export enum RoleEnum {
  SUPER_ADMIN = "SUPER_ADMIN",
  ADMIN = "ADMIN",
  USER = "USER",
  READER = "READER",
}

export type UserType = {
  _id: string
  workspaceName: string
  password: string
  lastName: string
  firstName: string
  email: string
  integrations: DataConnectorsType[]
  companies?: string[] // Array of company IDs the user belongs to
  primaryCompanyId?: string // Primary company ID for the user
  confirmed: boolean
  companyName: string
  role?: RoleEnum
}
